function hasClass(s,a) {
  return s.classList?s.classList.contains(a):!!s.className.match(new RegExp("(\\s|^)"+a+"(\\s|$)"))
}

export function addClass(s,a) {
  s.classList?s.classList.add(a):hasClass(s,a)||(s.className+=" "+a)
}

export function removeClass(s,a) {
  if(s.classList)s.classList.remove(a);else if(hasClass(s,a)){var e=new RegExp("(\\s|^)"+a+"(\\s|$)");s.className=s.className.replace(e,"")}
}

export function closest(e,t){
  var o;["matches","webkitMatchesSelector","mozMatchesSelector","msMatchesSelector","oMatchesSelector"].some(function(e){return"function"==typeof document.body[e]?(o=e,!0):!1});for(var c;e;){if(c=e.parentElement,c&&c[o](t))return c;e=c}return null;
}

export function getJSON(e,n,o,s,t){var r=new XMLHttpRequest;r.open(e,n,!0),"GET"==e?r.responseType="json":r.setRequestHeader("Content-type","application/x-www-form-urlencoded"),r.onload=function(){var e=r.status;200==e||201==e||202==e?s&&s(r.response):t&&t(r.response)},r.send(o)};

export function getJSON_and_status(e,n,o,s,t){var r=new XMLHttpRequest;r.open(e,n,!0),"GET"==e?r.responseType="json":r.setRequestHeader("Content-type","application/x-www-form-urlencoded"),r.onload=function(){var e=r.status;200==e||201==e||202==e?s&&s(r.response):t&&t(r.response, e)},r.send(o)};

export function getJSON_and_pass(e,n,o,s,t){var r=new XMLHttpRequest;r.open(e,n,!0),r.setRequestHeader("Authorization","Basic Y2xpZW50LWFwaToyeHBaVzUwTFdGd2E="),"GET"==e?r.responseType="json":r.setRequestHeader("Content-type","application/x-www-form-urlencoded"),r.onload=function(){var e=r.status;200==e||201==e||202==e?s&&s(r.response):t&&t(r.response)},r.send(o)};

export function clearFormError(id){var e=document.getElementById(id);addClass(e,"form-error__clear"),setTimeout(function(){e.innerHTML="",removeClass(e,"form-error__clear")},300) }



// WEBPACK FOOTER //
// ./src/components/GlobalFunctions.js